

<div class="modal-header text-center">
  <h4 class="modal-title font-size-large">Add {{typeText}}</h4>
</div>
<div class="modal-body">
  <form class="flex flex-column" novalidate [formGroup]="adminForm">

    <mat-form-field>
      <input matInput type="text" placeholder="{{placeholder}}" [readonly]=true formControlName="custId">
    </mat-form-field>
    <mat-form-field>
      <input matInput type="text" placeholder="Enter {{typeText}} Name(As Per Photo ID)" formControlName="name">
      <span mdSuffix>
        <i><img src="../../../assets/svg/baseline_person_black_24dp.png"></i>
      </span>
      <mat-error>Name should contain only Alphabets</mat-error>
    </mat-form-field>

    

    <mat-form-field>
      <input matInput type="tel" placeholder="Enter Mobile Number" formControlName="mobileNo">
      <span mdSuffix>
        <i><img src="../../../assets/svg/baseline_smartphone_black_24dp.png"></i>
      </span>
    </mat-form-field>
    <mat-form-field>
      <input matInput type="text" placeholder="Residence - Unit No, Building Name, Property No (as applicable)"
        formControlName="resUnitNo">
    </mat-form-field>

    <mat-form-field>
      <input matInput type="text" placeholder="Residence Address" formControlName="resAdd">
    </mat-form-field>


    <mat-form-field>
      <input matInput type="text" placeholder="Office - Unit No, Building Name, Property No (as applicable)"
        formControlName="offUnitNo">
    </mat-form-field>
    <mat-form-field>

      <input matInput type="text" placeholder="Office Address" formControlName="offAdd">
    </mat-form-field>

  </form>
</div>
<div class="modal-footer">
    <button color="primary" mat-button type="submit" (click)="onFormSubmit(adminForm.value)" [disabled]="!adminForm.valid">Add</button>
    <button color="primary" mat-button  (click)="onCancel()" type="button">Cancel</button>
</div>
